var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.97 7.23c.427.428 1.122.375 1.443-.107a.924.924 0 0 0-.107-1.283C22.776 2.47 19.622.76 14.38 1.027 8.874 1.295 4.008 4.182 4.33 10.278c.267 5.401 5.508 7.38 10.106 9.144 3.53 1.337 6.631 2.514 6.792 5.027.16 2.78-2.674 4.437-5.134 4.598-4.652.267-7.38-1.39-10.427-4.332a.99.99 0 0 0-1.337-.053c-.428.374-.428 1.016-.054 1.444 3.423 3.422 6.952 5.133 12.086 4.866 5.133-.375 11.443-3.262 11.122-9.358-.267-5.294-5.294-7.273-9.84-8.984-3.742-1.443-7.218-2.78-7.378-5.828-.107-2.192 2.513-3.796 4.384-3.903 4.546-.215 7.38 1.39 10.32 4.33zm.587 14.492c0 2.353-1.283 4.385-3.208 5.561l-.108-.053c.695-.963.802-2.193.802-3.37 0-3.475-3.797-4.812-7.807-6.256-4.439-1.604-9.09-3.262-9.09-7.967 0-2.14.962-4.439 2.833-5.508l.054.106c-.482 1.016-.696 2.139-.696 3.262 0 3.85 4.225 5.4 8.503 7.005 4.386 1.604 8.717 3.208 8.717 7.219z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrt);
export default __webpack_public_path__ + "static/media/SCRT.4af79dfc482fb800fcc851971ee25112.svg";
export { ForwardRef as ReactComponent };